export const visit = (vm, at) => {
vm(require("foundations-components/lang/lt.lyaml"));
at({ "lt": { "placeholder": "vieta\u017Eym\u0117" } });
};